<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" destroy-on-close>
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>


    <a-form-model ref="form" :model="form" :rules="rules">
       <a-card title="商品信息">
           <div style="white-space: pre-wrap">
             <a-alert
             message="操作提示"
             :description="alertInfo"
             type="info"
             showIcon/>
           </div>

          <a-card title="基本信息">

          <a-form-model-item label="商品名称 " prop="goodsName" >
            <a-input v-model="form.goodsName" placeholder="请输入商品名称 " />
          </a-form-model-item>

            <a-form-model-item label="商品名称英文 " prop="goodsNameEn" >
              <a-input v-model="form.goodsName" placeholder="请输入商品名称 " />
            </a-form-model-item>

          <a-form-model-item label="状态" prop="status" v-if="form.id">
            <a-select v-model="form.status" placeholder="请选择状态">
              <a-select-option :value="1">上架</a-select-option>
              <a-select-option :value="0">下架</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="商品类型" prop="categoryId" >
            <a-select v-model="form.categoryId" placeholder="请选择商品类型">
              <a-select-option v-for="item in categoryList" :value="item.id" :key='item.id'>
              {{ item.categoryName }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="商品主图" prop="picture" >
            <file-upload type="image" :defaultList="form.pictureArr" :count="1"
                         @input="getImg($event, 'picture')"></file-upload>
          </a-form-model-item>
          <a-form-model-item label="相册" prop="photoAlbum" >
            <file-upload type="image" :defaultList="form.photoAlbumArr" :count="6"
                         @input="getImg($event, 'photoAlbum')"></file-upload>
          </a-form-model-item>
          </a-card>
          <a-card title="商品详情" :style="{ marginTop: '16px' }">
           <a-form-model-item label="商品描述" prop="description" >
             <editor v-model="form.description" />
           </a-form-model-item>
            <a-form-model-item label="商品描述英文" prop="descriptionEn" >
              <editor v-model="form.descriptionEn" />
            </a-form-model-item>
          </a-card>
<!--          <a-card title="商品规格" :style="{ marginTop: '16px' }">-->
<!--           -->
<!--          </a-card>-->
          <a-card title=" 服务与承诺" :style="{ marginTop: '16px' }">
           <a-form-model-item label="运费模板" prop="deliveryTemplateId" >
             <a-select v-model="form.deliveryTemplateId" placeholder="请选择运费模板">
               <a-select-option v-for="item in shippingTemplates" :key="item.id"
               :label="item.name" :value="item.id">{{ item.name }}</a-select-option>
             </a-select>
           </a-form-model-item>
          </a-card>

        </a-card>

<!--      <a-form-model-item label="商品价格" prop="price" >-->
<!--        <a-input-number :min="0" v-model="form.price" placeholder="请输入商品价格" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="需要积分数量" prop="requireScores"  v-if="form.type == 1 ">-->
<!--        <a-input-number :min="0" v-model="form.requireScores" placeholder="请输入需要积分数量" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="需要现金券数量" prop="cashCoupon"  v-if="form.type == 2 ">-->
<!--        <a-input-number :min="0" v-model="form.cashCoupon" placeholder="请输入需要现金券数量" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="是否包邮" prop="freePostage" >-->
<!--        <a-radio-group v-model="form.freePostage">-->
<!--          <a-radio :value="1">是</a-radio>-->
<!--          <a-radio :value="0">否</a-radio>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="运费金额" prop="freightMoney"  v-if="form.freePostage == 0 ">-->
<!--        <a-input-number :min="0" v-model="form.freightMoney" placeholder="请输入运费金额" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="兑换限制数量" prop="limitNum" v-if="form.type == 1 ">-->
<!--        <a-input-number :min="1" v-model="form.limitNum" placeholder="请输入兑换限制数量" />-->
<!--      </a-form-model-item>-->


      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGoodsInfo, addGoodsInfo, updateGoodsInfo } from '@/api/goods/goodsInfo'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";
import {guid} from "@/utils/ruoyi";
import {listGoodsCategory} from "@/api/goods/goodsCategory";
import Editor  from '@/components/Editor'
import {shippingTemplates} from "@/api/logistics";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    TagSelectOption,
    Editor
  },
  data () {
    return {
      isAdd:false,
      oldResult:null,
      submitLoading: false,
      formTitle: '',
      alertInfo: '标识“*”的选项为必填项，其余为选填项。\n 请按提示栏信息进行商品添加。\n 运费模式：不包邮         则使用运费模板计算运费。\n 图片上传时，第一张为默认缩略图，在产品展示时，会选择该图片，请注意！！！\n兑换商城的商品从胜天半子同步来的，暂不支持手动添加。',
      categoryList: [],
      companyList: [],
      shippingTemplates: [],
      // 表单参数
      form: {
        id: null,
        goodsName: null,
        goodsNameEn: null,
        goodsNameRu: null,
        categoryId: null,
        deliveryTemplateId: null,
        pictureCount: 1,
        pictureArr:[],
        picture: null,
        photoAlbumCount: 6,
        photoAlbumArr:[],
        photoAlbum: null,
        description: null,
        descriptionEn: null,
        price: null,
        status: 0,
        saleAmount: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsName: [
          { required: true, message: '商品名称 不能为空', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '商品类型不能为空', trigger: 'blur' }
        ],
        deliveryTemplateId: [
          { required: true, message: '运费模板不能为空', trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '商品主图不能为空', trigger: 'blur' }
        ],
        photoAlbum: [
          { required: true, message: '相册不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  filters: {
  },
  created () {
    this.initDate()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    initDate(){
      shippingTemplates({isDeleted:0}).then(res=>{
        this.shippingTemplates = res.data
      })
      listGoodsCategory({isDeleted:0}).then(res=>{
        this.categoryList = res.data
      })
    },

    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },


    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.oldResult = null
      this.isAdd=false
      this.formType = 1
      this.form = {
        id: null,
        goodsName: null,
        goodsNameEn: null,
        categoryId: null,
        deliveryTemplateId: null,
        pictureCount: 1,
        pictureArr:[],
        picture: null,
        photoAlbumCount: 6,
        photoAlbumArr:[],
        photoAlbum: null,
        description: null,
        descriptionEn: null,
        price: null,
        status: 0,
        saleAmount: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (type) {
      this.reset()
      this.formType = 1
      this.oldResult = 1
      this.open = true
      this.isAdd=true
      this.formTitle = '添加'
      this.initCategory(type)
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.open = true
      this.oldResult = row.type
      this.formType = 2
      const id = row ? row.id : ids
      getGoodsInfo({"id":id}).then(response => {
        this.form = response.data
        this.form.deliveryTemplateId = response.data.deliveryTemplateId + ""
        this.formTitle = '修改'
        let that = this
        this.form.photoAlbumArr = []
        if(this.form.photoAlbum){
          this.form.photoAlbum.split(',').forEach(item=>{
            that.form.photoAlbumArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: item,
              path: item
            })
          })
        }
        this.form.pictureArr = []
        this.form.pictureArr.push({
          uid: guid(8, 10),
          name: that.form.picture,
          status: 'done',
          halfUrl: that.form.picture,
          url: that.form.picture,
          path: that.form.picture
        })
      })

    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGoodsInfo(this.form).then(response => {
              if(response.success){
                this.$message.success(
                  '修改成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(
                  response.message,
                  3
                )
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGoodsInfo(this.form).then(response => {
              if(response.success){
                this.$message.success(
                  '新增成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(
                  response.message,
                  3
                )
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
